import React from 'react';

// Header logo - compact version with just icon and text side by side
export const HeaderLogo = ({ className = "" }) => {
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <svg 
                width="50" 
                height="40" 
                viewBox="0 0 200 140" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <g transform="translate(0, 5)">
                    <path d="M10 120 L190 120" stroke="#C8A86B" strokeWidth="6" strokeLinecap="round"/>
                    <path d="M100 20 C100 20 60 70 100 115 C140 70 100 20 100 20Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                    <path d="M100 115 C70 110 40 80 50 50 C65 70 95 100 100 115Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                    <path d="M100 115 C130 110 160 80 150 50 C135 70 105 100 100 115Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                    <path d="M30 80 C20 100 50 118 90 120" stroke="#C8A86B" strokeWidth="4" strokeLinecap="round" fill="none"/>
                    <path d="M170 80 C180 100 150 118 110 120" stroke="#C8A86B" strokeWidth="4" strokeLinecap="round" fill="none"/>
                </g>
            </svg>
            <div className="flex flex-col">
                <span className="font-body font-semibold text-[#4A4E4D] text-xl tracking-[0.15em] leading-none">SAPA</span>
                <span className="font-body font-light text-[#4A4E4D]/70 text-[9px] tracking-[0.1em] mt-0.5">THE SPA DIRECTORY</span>
            </div>
        </div>
    );
};

// Footer logo - white/inverted version
export const FooterLogo = ({ className = "" }) => {
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <svg 
                width="50" 
                height="40" 
                viewBox="0 0 200 140" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <g transform="translate(0, 5)">
                    <path d="M10 120 L190 120" stroke="#C8A86B" strokeWidth="6" strokeLinecap="round"/>
                    <path d="M100 20 C100 20 60 70 100 115 C140 70 100 20 100 20Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                    <path d="M100 115 C70 110 40 80 50 50 C65 70 95 100 100 115Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                    <path d="M100 115 C130 110 160 80 150 50 C135 70 105 100 100 115Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                    <path d="M30 80 C20 100 50 118 90 120" stroke="#C8A86B" strokeWidth="4" strokeLinecap="round" fill="none"/>
                    <path d="M170 80 C180 100 150 118 110 120" stroke="#C8A86B" strokeWidth="4" strokeLinecap="round" fill="none"/>
                </g>
            </svg>
            <div className="flex flex-col">
                <span className="font-body font-semibold text-white text-xl tracking-[0.15em] leading-none">SAPA</span>
                <span className="font-body font-light text-white/60 text-[9px] tracking-[0.1em] mt-0.5">THE SPA DIRECTORY</span>
            </div>
        </div>
    );
};

// Full logo for use in other places
const Logo = ({ className = "", size = "default" }) => {
    const sizes = {
        small: { width: 200, height: 160 },
        default: { width: 300, height: 240 },
        large: { width: 400, height: 320 }
    };

    const { width, height } = sizes[size] || sizes.default;

    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 500 400" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g transform="translate(150, 50)">
                <path d="M10 120 L190 120" stroke="#C8A86B" strokeWidth="6" strokeLinecap="round"/>
                <path d="M100 20 C100 20 60 70 100 115 C140 70 100 20 100 20Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                <path d="M100 115 C70 110 40 80 50 50 C65 70 95 100 100 115Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                <path d="M100 115 C130 110 160 80 150 50 C135 70 105 100 100 115Z" stroke="#C8A86B" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                <path d="M30 80 C20 100 50 118 90 120" stroke="#C8A86B" strokeWidth="4" strokeLinecap="round" fill="none"/>
                <path d="M170 80 C180 100 150 118 110 120" stroke="#C8A86B" strokeWidth="4" strokeLinecap="round" fill="none"/>
            </g>
            <text x="250" y="240" textAnchor="middle" fontFamily="'Manrope', sans-serif" fontWeight="600" fontSize="80" fill="#4A4E4D" letterSpacing="10">
                SAPA
            </text>
            <text x="250" y="290" textAnchor="middle" fontFamily="'Manrope', sans-serif" fontWeight="300" fontSize="24" fill="#4A4E4D" letterSpacing="3">
                THE SPA DIRECTORY
            </text>
        </svg>
    );
};

export default Logo;
